<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-06 17:38:12
 * @FilePath: 
 * @Description: 支付完成后页面
-->
<template>
  <div class="full_page">
    <div class="pay_result_con">
      <img
        v-if="showImg"
        :src="
          orderInfo.status == 0
            ? require('@/assets/images/pay_failed.png')
            : require('@/assets/images/paySuccess.png')
        "
        alt=""
      />
      <!-- <img
        v-if="orderInfo.status == 0 || orderInfo.status == 1"
        :src="
          orderInfo.status == 1
            ? require('@/assets/images/paySuccess.png')
            : require('@/assets/images/pay_failed.png')
        "
        alt=""
      /> -->
      <p class="c-font-26">{{ orderInfo.statusText }}</p>
      <p class="c-font-30">
        ￥<span class="c-font-40">{{ orderInfo.price }}</span>
      </p>
      <p class="c-font-24">{{ orderInfo.payType }}</p>
    </div>
    <!-- <van-cell title="支付方式" :value="orderInfo.payType" /> -->
    <div class="c-btm-box c-f-ar">
      <van-button color="var(--tc)" round block plain @click="handleToHome"
        >返回首页</van-button
      >
      <span style="width: 20px"></span>
      <van-button color="var(--tc)" round block @click="handleViewOrder"
        >查看订单</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

import { getGoodOrderDetail } from "@/api/order";
import { handleLocalStorage, handleSessionStorage } from "@/utils";
export default {
  name: "CollageSubmission",
  props: {},
  data() {
    return {
      showImg: false,
      orderInfo: {},
    };
  },
  components: {},
  created() {
    this.orderId = handleLocalStorage.get("orderId");
    Toast.loading({
      // mask: true, //蒙层
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: "spinner",
      message: "支付结果查询中...",
    });
    setTimeout(() => {
      this.handleGetFoodInfo();
    }, 3000);
  },
  mounted() {},
  methods: {
    async handleGetFoodInfo() {
      const orderRes = await getGoodOrderDetail({ id: this.orderId });
      Toast.clear();

      let statusText = "";
      if (orderRes.Status == 0) {
        statusText = "支付失败";
      } else {
        statusText = "支付成功";
      }
      //  if (orderRes.Status == 1) {
      //   statusText = "支付成功";
      // }
      //  else if (orderRes.Status == 2) {
      //   statusText = "订单取消";
      // } else if (orderRes.Status == 3) {
      //   statusText = "订单退款中";
      // } else if (orderRes.Status == 4) {
      //   statusText = "订单已退款";
      // } else if (orderRes.Status == 5) {
      //   statusText = "订单已完成";
      // }
      this.orderInfo = {
        payType: orderRes.PayType,
        status: orderRes.Status,
        statusText: statusText,
        // price: orderRes.Details[0].SettlePrice,
        price: orderRes.FactPayMoney,
      };
      this.showImg = true;
      this.vpnSaaSCode = orderRes.SaasVpnCode;
      const vpnInfo = {
        // name: item.Name,
        code: orderRes.SaasVpnCode,
        id: orderRes.VpnId,
        // payAfterMeal: item.SaasVpnSetting.PayAfterMeal,
        // wechatPayChannel: item.SaasVpnSetting.WechatPayChannel,
      };
    },
    handleToHome() {
      this.$router.replace("/homePage/homePage");
    },
    handleViewOrder() {
      this.$router.replace("/homePage/order");
    },
  },
};
</script>
<style scoped lang="scss">
.pay_result_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  background: #fff;

  img {
    width: 100px;
    margin: 30px 0 20px;
  }
  p {
    margin-bottom: 20px;
    color: #333;
    &:last-child {
      font-size: 28px;
    }
  }
}
</style>
